<template>
  <div class="payment-info">
    <div class="bg"></div>
    <div class="payment-container">
      <div class="head">
        <span class="price">待支付：￥{{ orderInfo.amountFinal }}</span>
        <span class="pay-time">请在{{countdownTime[0]}}分{{countdownTime[1]}}秒内完成支付</span>
      </div>
      <ul class="payment-info-box">
        <li><span>停车时长</span><span class="colorFF8200">{{ orderInfo.parkingTime }}</span></li>
        <li><span>车牌</span><span class="colorFF8200">{{ orderInfo.carLicense }}</span></li>
        <li><span>入场时间</span><span class="color999">{{ orderInfo.entranceTime }}</span></li>
        <li><span>停车场名</span><span class="color999">{{ orderInfo.parkingLotName }}</span></li>
        <li><span>总计</span><span class="color999">￥{{ orderInfo.amountTotal }}</span></li>
        <li><span>优惠折扣</span><span class="color999">-￥{{ orderInfo.amountCoupon }}</span></li>
        <li class="noboder"><span>场内支付</span><span class="color999">-￥{{ orderInfo.payedAmount }}</span></li>
      </ul>
      <ul class="paytype">
        <li v-for="item in paymentList" :key="item.preCode" @click="selectPayment(item.preCode)">
          <span><img class="paytype-icon" :src="'http://image.scsonic.cn/'+item.payIcon" alt="">{{item.payName}}</span>
          <img v-if="selectedCode == item.preCode" src="@/assets/image/select.png" alt="" class="select-icon">
          <img v-else src="@/assets/image/nochoice.png" alt="" class="select-icon">
        </li>
        <!-- <li @click="selectPayment('103')">
          <span><img class="paytype-icon" src="@/assets/image/zhifu.png" alt="">支付宝支付</span>
          <img v-if="selectedCode == 103" src="@/assets/image/select.png" alt="" class="select-icon">
          <img v-else src="@/assets/image/nochoice.png" alt="" class="select-icon">
        </li> -->
      </ul>
      <ChargeRule :parkingLotId="orderInfo.parkingLotId" />
    </div>
    <div class="pay-box">
      <span class="price">实付金额：￥{{ orderInfo.amountFinal }}</span>
      <van-button class="pay-btn" type="info" @click="canPay && payBtn()">立即支付</van-button>
    </div>

  </div>
</template>

<script>
import ChargeRule from "@/components/ChargeRule"
import { apiOrderDetail, apiGetPayList, apiUnifiedOrder } from "@/utils/api"
import { formatCountDownTime } from "@/utils/common"
import { Toast, Notify, Dialog } from 'vant'

export default {
  name: 'PaymentInfo',
  mixins: [],
  components: {
    ChargeRule
  },
  props: {},
  data () {
    return {
      orderInfo: {
        agentId: '',
        brandId: '',
        estateId: '',
        recordId: '',
        parkingLotId: '',
        parkingNo: '',
        parkingLotName: '',
        carLicense: '',
        parkingTime: '',
        entranceTime: '',
        amountTotal: '',
        amountCoupon: '',
        amountFinal: '',
        payedAmount: '',
        payable: '',
        payableTip: '',
      },
      paymentList: [],
      timer: null,
      countdownTime: ["--", "--"],
      canPay: false,
      payParam: null,
      showTips: false,
      sceneType: '',
      tradeId: '',
      msg: '',
      selectedCode: '',
      openId: ''
    }
  },
  computed: {},
  watch: {},
  created () {
    let urlParam = this.$route.query
    this.openId = urlParam.openid
    this.getOrderDetail()
  },
  mounted () {},
  destroyed () {},
  methods: {
    getOrderDetail (){
      let that = this
      let param = {
        parkingNo: this.$route.query.orderNo
      }
      apiOrderDetail(param)
      .then(result => {
        if (result.status == "200") {
          if (result.data.payable == 0) {
            Notify({type: "danger",message: result.data.payableTip})
            return
          }

          that.orderInfo = result.data
          that.getPaymentList()
        } else {

        }
      })
      .catch(err => {
        window.console.log(err)
      })
    },
    getPaymentList (){
      let that = this
      let param = {
        parkingLotId: this.orderInfo.parkingLotId,
        client: 'A'
      }
      apiGetPayList(param)
      .then(result => {
        if (result.status == "200") {
          console.log(result.data.length)
          if(result.data.length == 0){
            Notify({type: "danger",message: '未配置支付渠道,无法完成支付,请联系管理员', duration: 4000})
          }else{
            this.$nextTick(() =>{
              that.paymentList = result.data
              that.selectedCode = result.data[0].preCode
              that.setTimer()
              that.canPay = true
            })
          }
        } else {
          Notify({type: "danger",message: result.message})
        }
      })
      .catch(err => {
        window.console.log(err)
      })
    },
    setTimer(t) {
      let time = t ? t : 300;
      this.timer = setInterval(() => {
        this.countdownTime = formatCountDownTime(time).split(":")
        time--
        if (time < 0) {
          clearInterval(this.timer)
          this.timer = null
          // location.reload()
          Toast.loading({
            message: '订单过期，自动刷新...',
            forbidClick: true,
            overlay: true,
            loadingType: 'spinner',
            duration: 1000,
            onClose: function(){
              location.reload()
            }
          })
        }
      }, 1000);
    },
    selectPayment (preCode){
      this.selectedCode = preCode
      console.log(preCode)
    },
    payBtn (){
      let that = this
      if(this.orderInfo.amountFinal == 0){
        Notify({ type: "danger", message: '您无需支付费用' })
        return
      }

      this.payParam = {
        openId: this.openId,
        unionId: localStorage.getItem('unionid'),
        sceneType: this.selectedCode+'A1004',
        carLicense: this.orderInfo.carLicense,
        dataId: this.orderInfo.recordId,
        parkingLotId: this.orderInfo.parkingLotId,
        brandId: this.orderInfo.brandId,
        estateId: this.orderInfo.estateId,
        agentId: this.orderInfo.agentId,
        incomeName: this.orderInfo.carLicense + "停车缴费",
        amountTotal: this.orderInfo.amountTotal,
        amountDiscount: this.orderInfo.amountCoupon,
        amountCurrentPay: this.orderInfo.amountFinal,
        entranceTime: this.orderInfo.entranceTime
      }

      Toast.loading("拉起支付中...")
      apiUnifiedOrder(this.payParam)
      .then(result => {
        if (result.status == "200") {
          if (result.data.success) {
            that.sceneType = result.data.sceneType
            that.tradeId = result.data.tradeId

            that.wxPay(result.data)
          } else {
            Toast.clear()
            Notify({ type: "danger", message: result.data.message })
          }
        } else if (result.status == "111") {
          Toast.clear()
          Dialog.alert({
            title: '提示信息',
            message: result.message,
          }).then(() => {
            // on close
          })
        } else {
          Toast.clear()
          Notify({ type: "danger", message: result.message })
        }
      })
      .catch(err => {
        window.console.log(err)
      })
    },
    wxPay (payParam){
      if(payParam.payUrl){
        window.location.href = payParam.payUrl
      }else{
        let obj = payParam.jsApiObject
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              this.onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady)
            document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady)
          }
        } else {
          this.onBridgeReady(obj);
        }
      }
    },
    onBridgeReady(obj) {
      Toast.clear();
      let that = this
      WeixinJSBridge.invoke("getBrandWCPayRequest",
        {
          appId: obj.appId, //公众号名称，由商户传入
          timeStamp: obj.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: obj.nonceStr, //随机串
          package: obj.package,
          signType: obj.signType, //微信签名方式：
          paySign: obj.paySign //微信签名
        },
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            const param = {
              tradeId: that.tradeId,
              dataId: that.payParam.dataId,
              parkingLotId: that.payParam.parkingLotId,
              sceneType: that.sceneType
            };
            that.$router.push({
              path: "/paysuccess",
              query: param
            });
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            window.console.log("用户取消支付")
            Toast("已取消支付")
          } else {
            Notify({ type: "danger", message: res.err_msg })
          }
        }
      )
    }
  },
}
</script>

<style scoped lang="scss">
.payment-info{
  .bg{
    width: 100%;
    height: 320px;
    background: url('../../assets/image/bjinformation.png');
    background-size: cover;
    position: absolute;
    z-index: -1;
  }
  .payment-container{
    padding: 30px;
    .head{
      text-align-last: left;
      margin-top: 30px;
      margin-bottom: 30px;
      .price{
        font-size: 40px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        display: block;
      }
      .pay-time{
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
    .payment-info-box{
      width: 690px;
      height: 633px;
      background: #FFFFFF;
      box-shadow: 0px 4px 20px 0px rgba(174, 185, 190, 0.7);
      border-radius: 10px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      padding: 0 25px;
      box-sizing: border-box;
      margin-bottom: 29px;
      li{
        display: flex;
        justify-content: space-between;
        height: 86px;
        line-height: 86px;
        border-bottom: 2px solid #E5E5E5;
        padding: 0 22px 0 13px;
        .color999{
          color: #999;
        }
        .colorFF8200{
          color: #FF8200;
        }
      }
      li.noboder{
        border-bottom: 0;
      }
    }
    .paytype{
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      width: 690px;
      background: #FFFFFF;
      box-shadow: 0px 4px 20px 0px rgba(174, 185, 190, 0.7);
      border-radius: 10px;
      padding: 0 25px;
      box-sizing: border-box;
      li{
        display: flex;
        justify-content: space-between;        
        align-items: center;
        height: 96px;
        line-height: 96px;
        border-bottom: 2px solid #E5E5E5;
        .paytype-icon{
          width: 38px;
          height: 38px;
          vertical-align: middle;
          margin-right: 19px;
          display: inline-block;
        }
        .select-icon{
          width: 38px;
          height: 38px;
        }
      }
      li:last-child{
        border-bottom: 0;
      }
    }
  }
  .pay-box{
    position: fixed;
    width: 100%;
    height: 200px;
    bottom: 0;
    text-align: center;
    background-color: #fff;
    box-shadow: 0px -2px 5px 0px rgba(174, 185, 190, .5);
    .price{
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FF7F00;
      line-height: 60px;
    }
    .pay-btn{
      width: 600px;
      height: 80px;
      background: linear-gradient(-67deg, #26A0A5, #8DE9C6);
      border-radius: 40px;
      border: none;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      margin-bottom: 30px;
    }
  }

}
</style>